module.exports = __webpack_public_path__ + "media/images/blobs/blob-orange-b165a0cd9dc8eacb5324fb4e3b71372a.svg";